import { useState } from 'react';

import { scrollToBottom } from '@/utils/helpers';

/**
 * Хук скролла к блоку цен.
 * @returns {{ isScrollingToPrices: boolean, scrollToPrices: Function }}
 */
export const useScrollToPrices = () => {
  const [isScrolling, setIsScrolling] = useState(false);

  const scrollToPrices = () => {
    setIsScrolling(true);
    scrollToBottom({ onDone: () => setIsScrolling(false) });
  };

  return { isScrollingToPrices: isScrolling, scrollToPrices };
};
